var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 0H23.5C23.7761 0 24 0.223846 24 0.5V3.5C24.0002 3.63269 23.9477 3.76004 23.854 3.854L22.561 5.147L23.067 6.95599C23.1722 7.33081 23.0503 7.73264 22.7546 7.98584C22.4589 8.23907 22.0432 8.29764 21.689 8.13599L20.233 7.474L19.507 8.20001L19.868 10.616C19.92 10.9592 19.7902 11.3048 19.5252 11.5291C19.2602 11.7533 18.8979 11.824 18.568 11.716L16.635 11.072L14.323 13.385C15.8302 16.6856 14.7584 20.5918 11.7779 22.6611C8.79742 24.7304 4.763 24.3694 2.19733 21.8036C-0.368347 19.238 -0.729431 15.2036 1.3399 12.2231C3.40921 9.24255 7.3154 8.17084 10.616 9.67801L20.146 0.147003C20.2398 0.0529175 20.3672 3.05176e-05 20.5 0ZM5.5 20C6.32843 20 7 19.3284 7 18.5C7 17.6716 6.32843 17 5.5 17C4.67157 17 4 17.6716 4 18.5C4 19.3284 4.67157 20 5.5 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.a467bd50.svg";
export { ForwardRef as ReactComponent };